import axios from 'axios';
import config from '../config';

const METHOD = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  FETCH: 'FETCH',
  DELETE: 'DELETE',
};

const Axios = axios.create({
  baseURL: config.apiBaseUrl,
});

class Request {
  static token;
  static sid;

  constructor() {
    let token;
    let sid;
    if (typeof window === 'object') {
      token = window.localStorage.getItem('_accessToken');
      sid = window.localStorage.getItem('SID');
    }
    this.token = token;
    this.sid = sid;
  }

  setToken(token) {
    this.token = token;
  }

  setSid(sid) {
    this.sid = sid;
  }

  async get(path, signal) {
    return await Request.asyncFetch({
      path,
      method: METHOD.GET,
      token: this.token,
      sid: this.sid,
      signal,
    });
  }

  async post(path, body, signal) {
    return await Request.asyncFetch({
      path,
      method: METHOD.POST,
      token: this.token,
      sid: this.sid,
      body,
      signal,
    });
  }

  async put(path, body, signal) {
    return await Request.asyncFetch({
      path,
      method: METHOD.PUT,
      token: this.token,
      sid: this.sid,
      body,
      signal,
    });
  }

  async delete(path, signal) {
    return await Request.asyncFetch({
      path,
      method: METHOD.DELETE,
      token: this.token,
      sid: this.sid,
      signal,
    });
  }

  async rawAxios({ path, method, data, headers }) {
    return await Axios(path, {
      method,
      data,
      headers,
    });
  }

  static async asyncFetch({ path, method, token, sid, body, signal }) {
    const headers = { 'Content-type': 'application/json' };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    if (sid) {
      headers['X-Session-Id'] = sid;
    }

    const { data } = await Axios(path, {
      method,
      data: body,
      headers,
      signal,
    });

    return data;
  }
}

const request = new Request();

export default request;
